import React from 'react'
import Layout from '../Components/Layouts/Layout'
import { Link } from 'react-router-dom'
import Banner from '../images/banner.jpeg'
import { backdropClasses } from '@mui/material'
import '../Style/Homestyle.css'

const Home = () => {
  return (
   
      <Layout>
        <div className="home" style={{ backgroundImage: `url(${Banner})` }}>
          <div className="headercontainer">
            <h1>Food Frenzy.</h1>
            <p>Desire meets a new Food.</p>
           <Link to="/menu"><button>
              Order Now
            </button></Link>
            
          </div>
        </div>
      </Layout>
   

  )
}

export default Home
